import React from 'react';
import './DashboardFooter.css';

const DashboardFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="dashboard-footer">
      <div className="footer-content">
        <div className="footer-copyright">
          <p>&copy; {currentYear} Australian Film Society Federation. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default DashboardFooter;
